import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Input,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Checkbox,
  Text,
  IconButton,
  Stack,
  Spinner,
  useToast,
  Image,
} from "@chakra-ui/react";
import { AddIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { Link as RouterLink } from "react-router-dom";
import { Link as ChakraLink } from "@chakra-ui/react";
import axios from "axios";
import * as mod from "../../url";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar/Navbar";
const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
const token = storedData?.data?.token;
const config = { headers: { Authorization: `${token}` } };
const SIDEBAR_WIDTH = "250px";
const RECORDS_PER_PAGE = 20;

const ManageAllVideos = () => {
  const [allVideo, setAllVideo] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  //   console.log(allVideo, "allVideo");
  // Fetch  from API
  const fetchAllVideo = async () => {
    try {
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/video/get-all-video`
      );
      //   console.log(data, "ijoijdsps");
      setAllVideo(data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching :", error);
      setLoading(false);
    }
  };

  const handleStatusToggle = async (_id, currentStatus) => {
    const videotatus = currentStatus === "active" ? "inactive" : "active";
    try {
      await axios.put(
        `${mod.api_url}/api/v1/video/video_status/${_id}`,
        { status: videotatus },
        config
      );

      setAllVideo((prevStory) =>
        prevStory.map((video) =>
          video._id === _id ? { ...video, status: videotatus } : video
        )
      );
    } catch (error) {
      console.error("Failed to update status", error);
    }
  };

  useEffect(() => {
    fetchAllVideo();
  }, []);
  const handleDelete = async (_id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this video?"
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(
        `${mod.api_url}/api/v1/video/delete-video/${_id}`,
        config
      );

      // Update state to remove the deleted video
      setAllVideo((prevStory) =>
        prevStory.filter((video) => video?._id !== _id)
      );

      toast({
        title: "Draft deleted successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Delete error:", error);
      toast({
        title: "Failed to delete video.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Pagination calculation
  const totalPages = Math.ceil(allVideo?.length / RECORDS_PER_PAGE);
  const startIdx = (currentPage - 1) * RECORDS_PER_PAGE;
  const currentRecords = allVideo.slice(startIdx, startIdx + RECORDS_PER_PAGE);

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box mt="70px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={3}>
        <Text fontSize="2xl" mb={4} size="md" bg="#D29B3F" p={3}>
          <strong>All video</strong>
        </Text>

        <Flex
          bg="white"
          p={4}
          mb={4}
          borderRadius="md"
          boxShadow="sm"
          align="center"
          flexWrap="wrap"
          gap={4}
        >
          <Input
            placeholder="Enter title, name or keyword to search record"
            maxW="300px"
          />

          <Flex ml="auto">
            <Button
              colorScheme="blue"
              leftIcon={<AddIcon />}
              as={RouterLink}
              to="/create-video"
              _hover={{ bg: "blue.100" }}
              textDecoration="none"
            >
              Add New Record
            </Button>
          </Flex>
        </Flex>

        <Box bg="white" p={4} borderRadius="md" boxShadow="sm">
          <Text fontSize="sm" mb={1} textAlign={"right"} align={"right"}>
            Total Record: {allVideo?.length}
          </Text>
          {/* <Text fontSize="sm"></Text> */}
          {loading ? (
            <Spinner size="xl" />
          ) : (
            <>
              <Table
                variant="simple"
                size="sm"
                style={{ border: "1px solid #ccc", borderCollapse: "collapse" }}
              >
                <Thead bg="gray.100">
                  <Tr>
                    {/* <Th border="1px solid #ccc">
                      <Checkbox />
                    </Th> */}
                    {/* <Th border="1px solid #ccc">Sr. No</Th> */}
                    <Th border="1px solid #ccc">ID</Th>
                    <Th border="1px solid #ccc">Image</Th>
                    <Th border="1px solid #ccc">Title</Th>
                    <Th border="1px solid #ccc">Posted on</Th>
                    <Th border="1px solid #ccc">Action</Th>
                    <Th border="1px solid #ccc">Delete</Th>
                    <Th border="1px solid #ccc">Status</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {currentRecords?.map((video, index) => (
                    <Tr key={video?._id}>
                      {/* <Td border="1px solid #ccc">
                        <Checkbox />
                      </Td> */}
                      <Td border="1px solid #ccc">{startIdx + index + 1}</Td>
                      <Td border="1px solid #ccc">
                        <Image
                          src={`https://img.youtube.com/vi/${
                            video?.videoUrl.includes("v=")
                              ? video?.videoUrl.split("v=")[1]?.split("&")[0] // https://www.youtube.com/watch?v=VIDEOID
                              : video?.videoUrl.split("/").pop() // https://youtu.be/VIDEOID
                          }/hqdefault.jpg`}
                          alt="YouTube Thumbnail"
                          width="120px"
                          height="80px"
                          style={{ objectFit: "cover" }}
                        />
                      </Td>

                      <Td border="1px solid #ccc">
                        <ChakraLink
                          as={RouterLink}
                          to={`/single-video/${video?._id}`} // navigate to single video page
                          color="blue.500"
                          _hover={{ textDecoration: "underline" }}
                        >
                          {video?.title.slice(0, 100)}
                        </ChakraLink>
                      </Td>

                      <Td border="1px solid #ccc">
                        {new Date(video?.postedOn).toLocaleDateString()}
                      </Td>
                      <Td border="1px solid #ccc">
                        <ChakraLink
                          as={RouterLink}
                          to={`/update-video/${video?._id}`} // navigate to single video page
                          color="blue.500"
                          _hover={{ textDecoration: "underline" }}
                        >
                          <IconButton
                            icon={<EditIcon />}
                            colorScheme="blue"
                            size="sm"
                            aria-label="Edit"
                          />
                        </ChakraLink>
                      </Td>

                      <Td border="1px solid #ccc">
                        <IconButton
                          icon={<DeleteIcon />}
                          colorScheme="red"
                          size="sm"
                          aria-label="Delete"
                          onClick={() => handleDelete(video?._id)}
                        />
                      </Td>
                      <Td border="1px solid #ccc">
                        <Button
                          size="sm"
                          colorScheme={
                            video?.status === "active" ? "green" : "red"
                          }
                          onClick={() =>
                            handleStatusToggle(video?._id, video?.status)
                          }
                        >
                          {video?.status === "active" ? "Active" : "Inactive"}
                        </Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>

              {/* Pagination */}
              <Flex justify="space-between" align="center" mt={4}>
                <Stack direction="row" spacing={2}>
                  {Array.from({ length: totalPages }).map((_, idx) => (
                    <Button
                      key={idx}
                      size="sm"
                      onClick={() => setCurrentPage(idx + 1)}
                      colorScheme={currentPage === idx + 1 ? "blue" : "gray"}
                      variant={currentPage === idx + 1 ? "solid" : "outline"}
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </Stack>
              </Flex>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default ManageAllVideos;
